import { sum } from 'Shared/util/calculations';


const MAX_TOTAL_ALLOWED_FILE_SIZE = 29360128;// bytes = 28 MB


export const exceedsTotalAllowedFileSize = (newFiles, existingFiles) => {
  const totalFileSize = (sum(newFiles, 'size') + sum(existingFiles, 'size'));
  return (totalFileSize > MAX_TOTAL_ALLOWED_FILE_SIZE);
};

export const getProgressBarSizeAndPercentage = (files) => {
  const totalBytes = sum(files, 'size');
  const sizeInMB = (totalBytes / (1024 * 1024));
  const percentageOfMax = ((totalBytes / MAX_TOTAL_ALLOWED_FILE_SIZE) * 100);

  return {
    progressBarSize: parseFloat(sizeInMB.toFixed(1)),
    progressBarPercentage: parseFloat(percentageOfMax.toFixed(2)),
  };
};
